/* eslint-disable */
import { Modal, Select, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { BasicFormWrapper } from '../styled';
import { AddProductForm } from '../service/Style';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {
    BASEURL,
    IG_APP_ID,
    SERVICES,
    options,
    urlRegex,
} from '../../helpers/constants';
import {
    delImage,
    getDetails,
    resetInstaFiles,
    updateDetails,
} from '../../redux/businessAccount/detailsAction';
import { useDispatch } from 'react-redux';
import { Autocomplete } from '@react-google-maps/api';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import TextArea from 'antd/lib/input/TextArea';
import Loading from '../../components/Loading';
import SVG from '../steps/SVG';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import Navbar from '../Navbar';
import { axiosInstance } from '../../repository/Repository';
import UploadFromInsta from './UploadFromInsta';
import { useRef } from 'react';
import { plusIcon } from '../../assets/images/sidebarIcons';
import moment from 'moment';
import { StopOutlined } from '@ant-design/icons';
import { fetchAllBusinessNames } from '../../redux/services/servicesActions';

const Setting = () => {
    const { businessDetails, updateLoading, fetchLoading, instaImgFiles } =
        useSelector((state) => state.businessDetails);
    const { businessNames } = useSelector((state) => state.services);
    const { userData } = useSelector((state) => state.user);
    const [name, setName] = useState('');
    const [about, setAbout] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [images, setImages] = useState([]);
    const [location, setLocation] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [fb, setFb] = useState('');
    const [insta, setInsta] = useState('');
    const [website, setWebsite] = useState('');
    const [routine, setRoutine] = useState({});
    const [data, setData] = useState();
    const [searchTerm, setSearchTerm] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [applyAll, setApplyAll] = useState(false);
    const [selectedServices, setSelectedServices] = useState([]);
    const [isOnline, setIsOnline] = useState(false);
    const [errors, setErrors] = useState({});
    const [cancellationType, setCancellationType] = useState('Moderate');
    const [policies, setPolicies] = useState('');
    const [bookingPeriod, setBookingPeriod] = useState(null);
    const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] =
        useState(false);
    const [isCancelling, setIsCancelling] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const [isCancellationTypeOpen, setCancellationTypeOpen] = useState(false);
    const cancellationRef = useRef(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedDay, setSelectedDay] = useState(null);
    const [bufferTime, setBufferTime] = useState(null);
    const [depositPercentage, setDepositPercentage] = useState(0);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (
                cancellationRef.current &&
                !cancellationRef.current.contains(event.target)
            ) {
                setCancellationTypeOpen(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    const cancellationTypes = [
        {
            title: 'strict',
            description: 'No cancellations allowed. No refunds',
        },
        {
            title: 'moderate',
            description:
                'Free cancellation up to 48 hours before the appointment.',
        },
        {
            title: 'flexible',
            description:
                'Free cancellation up to 24 hours before the appointment.',
        },
    ];
    const toggleCancellationType = () => {
        setCancellationTypeOpen(!isCancellationTypeOpen);
    };

    const handleLocationLatLng = () => {
        const place = data.getPlace();
        setLocation(place?.formatted_address);
        const lat = place?.geometry?.location?.lat();
        const lng = place?.geometry?.location?.lng();
        setLatitude(lat);
        setLongitude(lng);
    };

    const filteredOptions = options.filter((country) =>
        country.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleCountryCodeClick = (_country) => {
        setCountryCode(_country.code);
    };

    const handleImageChange = (e) => {
        const files = e.target.files;
        const updatedImages = [...images];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileSize = file.size;
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!allowedTypes.includes(file.type)) {
                setErrors((prev) => ({
                    ...prev,
                    images: 'You can only upload an image file (JPEG, PNG, JPG)',
                }));
                e.target.value = '';
                return;
            }
            if (fileSize > 20000000) {
                setErrors((prev) => ({
                    ...prev,
                    images: 'File size exceeds 20 megabytes',
                }));
                e.target.value = '';
                return;
            }
            const previewPic = URL.createObjectURL(file);
            updatedImages.push({ file, previewPic });
        }
        setImages(updatedImages);
    };

    const handleIsOnline = (e) => {
        let checked = e.target.checked;
        if (checked) {
            setIsOnline(true);
            setLocation('');
            setLatitude('');
            setLongitude('');
        } else {
            setIsOnline(checked);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});

        const normalize = (str) => str.toLowerCase().replace(/\s+/g, '-');
        const normalizedBusinessNames = businessNames.map(normalize);
        const normalizedNewName = normalize(name);

        // Validate URLs
        const [website_valid, fb_valid, insta_valid] = await Promise.all([
            website ? urlRegex.test(website) : true,
            fb ? urlRegex.test(fb) : true,
            insta ? urlRegex.test(insta) : true,
        ]);

        let hasError = false;
        const newErrors = {};

        const existingBusinessName = userData?.business?.name || '';
        if (!name) {
            newErrors.name = 'Business name is required';
            hasError = true;
        } else if (
            normalize(existingBusinessName) !== normalizedNewName &&
            normalizedBusinessNames.includes(normalizedNewName)
        ) {
            newErrors.name = 'This business name already exists.';
            hasError = true;
        }

        if (!phone) {
            newErrors.phone = 'Contact Number is required';
            hasError = true;
        } else if (phone.length < 6 || phone.length > 14) {
            newErrors.phone = 'Mobile number must be between 6 to 14 digits';
            hasError = true;
        }

        if (selectedServices.length < 1) {
            newErrors.services = 'Select at least 1 service';
            hasError = true;
        }

        if (!website_valid) {
            newErrors.website =
                "Provide valid URL 'https://www.yourwebsite.com'";
            hasError = true;
        }
        if (!fb_valid) {
            newErrors.fb =
                "Provide valid URL 'https://www.facebook.com/yourpage'";
            hasError = true;
        }
        if (!insta_valid) {
            newErrors.insta =
                "Provide valid URL 'https://www.instagram.com/yourpage'";
            hasError = true;
        }

        if (hasError) {
            setErrors(newErrors);
            return;
        }

        setErrors({});

        const formData = new FormData();
        formData.append('name', name);
        formData.append('about', about);
        formData.append('phone', countryCode + '-' + phone);
        formData.append('address', location);
        formData.append('latitude', latitude);
        formData.append('longitude', longitude);
        formData.append('facebook', fb);
        formData.append('Instagram', insta);
        formData.append('website', website);
        formData.append('bookingPeriod', bookingPeriod);
        formData.append('policies', policies);
        formData.append('bufferTime', bufferTime);
        formData.append('depositPercentage', depositPercentage);
        formData.append('cancellationType', cancellationType);

        Object.entries(routine).forEach(([day, times]) => {
            if (times.isOpened && (times.from == null || times.to == null)) {
                toast.error(
                    'You must add "From" and "To" timings for open days'
                );
                hasError = true;
                return;
            }

            if (typeof times === 'object' && times !== null) {
                Object.entries(times).forEach(([key, value]) => {
                    if (key === 'blockedTimes' && Array.isArray(value)) {
                        value.forEach((block, index) => {
                            formData.append(
                                `openingTimes[${day}][blockedTimes][${index}][from]`,
                                block.from
                            );
                            formData.append(
                                `openingTimes[${day}][blockedTimes][${index}][to]`,
                                block.to
                            );
                        });
                    } else {
                        formData.append(`openingTimes[${day}][${key}]`, value);
                    }
                });
            }
        });

        if (images.length === 0) {
            toast.error(
                'Please upload at least one image related to your business.'
            );
            return;
        }
        images.forEach((item) => {
            formData.append('images', item.file);
        });

        selectedServices.forEach((item, index) => {
            formData.append(`categories[${index}]`, item);
        });

        if (hasError) {
            return;
        }

        dispatch(updateDetails(formData))
            .then((res) => {
                if (res.success) {
                    toast.success('Business info updated successfully');
                    dispatch(getDetails()).catch((error) => console.log(error));
                }
            })
            .catch((error) => {
                toast.error(error || 'Error updating business details');
            });
    };

    const handleRemoveImage = (id, index) => {
        const updatedImages = [...images];

        if (id) {
            if (images.length === 1) {
                toast.error('At least one business image is mendatory.');
                return;
            } else {
                dispatch(delImage(id))
                    .then((res) => {
                        if (res.success) {
                            // updatedImages.splice(index, 1);
                            // setImages(updatedImages);
                            dispatch(getDetails());
                            toast.success('Image deleted successfully');
                        }
                    })
                    .catch((error) => {
                        toast.error('Error deleting image');
                    });
            }
        } else {
            updatedImages.splice(index, 1);
            setImages(updatedImages);
        }
    };

    const handleServiceChange = (name) => {
        const updatedServices = selectedServices.includes(name)
            ? selectedServices.filter((_name) => _name !== name)
            : [...selectedServices, name];

        setSelectedServices(updatedServices);
    };

    const handleCancelSubscription = async () => {
        try {
            if (businessDetails?.subscription?.id) {
                setIsCancelling(true);
                const response = await axios.post('stripe/unsubscribe', {
                    user: businessDetails,
                });
                console.log('in response of cancel', response.data);
                // dispatch(setUser(response.data.user));
                dispatch(getDetails());
                history.push('/pricing-plan');
                setIsCancelling(false);
            }
        } catch (error) {
            setIsCancelling(false);
            toast.error(
                error?.response?.data?.message ||
                    'Unable to cancel subscription'
            );
        }
    };

    const handleRoutine = (dayOfWeek) => {
        const handleSelectChange = (dayOfWeek, field, value) => {
            setRoutine((prevRoutine) => {
                const updatedRoutine = { ...prevRoutine };

                if (applyAll) {
                    Object.keys(updatedRoutine).forEach((day) => {
                        updatedRoutine[day][field] = value;
                        if (field === 'isOpened' && !value) {
                            updatedRoutine[day].from = null;
                            updatedRoutine[day].to = null;
                            updatedRoutine[day].blockedTimes = [];
                        }
                    });
                } else {
                    updatedRoutine[dayOfWeek][field] = value;
                    if (field === 'isOpened' && !value) {
                        updatedRoutine[dayOfWeek].from = null;
                        updatedRoutine[dayOfWeek].to = null;
                        updatedRoutine[dayOfWeek].blockedTimes = [];
                    }
                }
                return updatedRoutine;
            });
        };

        const showModal = (dayOfWeek) => {
            setSelectedDay(dayOfWeek);
            setIsModalVisible(true);
        };

        const handleBlockTimeChange = (index, field, value) => {
            setRoutine((prevRoutine) => {
                const updatedRoutine = { ...prevRoutine };
                if (!updatedRoutine[selectedDay].blockedTimes) {
                    updatedRoutine[selectedDay].blockedTimes = [];
                }

                updatedRoutine[selectedDay].blockedTimes[index] = {
                    ...updatedRoutine[selectedDay].blockedTimes[index],
                    [field]: value,
                };

                return updatedRoutine;
            });
        };

        const addBlockTime = () => {
            setRoutine((prevRoutine) => {
                const updatedRoutine = { ...prevRoutine };
                if (!updatedRoutine[selectedDay].blockedTimes) {
                    updatedRoutine[selectedDay].blockedTimes = [];
                }

                updatedRoutine[selectedDay].blockedTimes.push({
                    from: null,
                    to: null,
                });
                return updatedRoutine;
            });
        };

        const removeBlockTime = (index) => {
            setRoutine((prevRoutine) => {
                const updatedRoutine = { ...prevRoutine };
                updatedRoutine[selectedDay].blockedTimes.splice(index, 1);
                return updatedRoutine;
            });
        };

        const handleOk = () => {
            setIsModalVisible(false);
        };

        const handleCancel = () => {
            setIsModalVisible(false);
        };

        return (
            <div
                className="d-flex align-items-center justify-content-between gap-2 flex-wrap"
                key={dayOfWeek}
            >
                <h6
                    className="f-14 mb-0 fw-normal poppins text-gray"
                    style={{ width: 80 }}
                >
                    {dayOfWeek}
                </h6>
                <div className="d-flex gap-2">
                    <Select
                        placeholder="From"
                        className="f-14 mb-3"
                        size="small"
                        value={routine[dayOfWeek]?.isOpened}
                        onChange={(value) =>
                            handleSelectChange(dayOfWeek, 'isOpened', value)
                        }
                    >
                        <Select.Option value={true}>Opened</Select.Option>
                        <Select.Option value={false}>Closed</Select.Option>
                    </Select>
                    {routine[dayOfWeek]?.isOpened && (
                        <>
                            <Select
                                style={{ width: 84 }}
                                className="f-14 py-0 mb-3"
                                placeholder="From"
                                size="small"
                                value={routine[dayOfWeek]?.from || null}
                                onChange={(value) =>
                                    handleSelectChange(dayOfWeek, 'from', value)
                                }
                            >
                                {Array.from(
                                    { length: 24 },
                                    (_, i) => i + 1
                                ).map((hour) => (
                                    <Select.Option
                                        key={hour}
                                        className="f-14"
                                        value={`${hour}:00`}
                                    >
                                        {`${hour}:00`}
                                    </Select.Option>
                                ))}
                            </Select>
                            <Select
                                style={{ minWidth: 84 }}
                                className="f-14 mb-3"
                                placeholder="To"
                                size="small"
                                value={routine[dayOfWeek]?.to || null}
                                onChange={(value) =>
                                    handleSelectChange(dayOfWeek, 'to', value)
                                }
                            >
                                {Array.from(
                                    { length: 24 },
                                    (_, i) => i + 1
                                ).map((hour) => (
                                    <Select.Option
                                        key={hour}
                                        className="f-14"
                                        value={`${hour}:00`}
                                    >
                                        {`${hour}:00`}
                                    </Select.Option>
                                ))}
                            </Select>
                        </>
                    )}
                    {routine[dayOfWeek]?.isOpened && (
                        <StopOutlined onClick={() => showModal(dayOfWeek)} />
                    )}
                </div>
                <Modal
                    title={`Block Time Slot for ${selectedDay}`}
                    visible={isModalVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    mask={false}
                >
                    {routine[selectedDay]?.blockedTimes?.map((slot, index) => {
                        let blockedHours = new Set();
                        routine[selectedDay]?.blockedTimes.forEach(
                            ({ from, to }) => {
                                if (from && to) {
                                    const start = parseInt(from);
                                    const end = parseInt(to);
                                    for (let i = start; i <= end; i++) {
                                        blockedHours.add(`${i}:00`);
                                    }
                                }
                            }
                        );

                        return (
                            <div
                                key={index}
                                className="d-flex gap-2 align-items-center mb-2"
                            >
                                <Select
                                    style={{ width: '45%' }}
                                    placeholder="From"
                                    value={slot.from || null}
                                    onChange={(value) =>
                                        handleBlockTimeChange(
                                            index,
                                            'from',
                                            value
                                        )
                                    }
                                >
                                    {Array.from(
                                        { length: 24 },
                                        (_, i) => `${i + 1}:00`
                                    )
                                        .filter(
                                            (hour) =>
                                                !blockedHours.has(hour) ||
                                                hour === slot.from
                                        )
                                        .map((hour) => (
                                            <Select.Option
                                                key={`from-${hour}`}
                                                value={hour}
                                            >
                                                {hour}
                                            </Select.Option>
                                        ))}
                                </Select>
                                <Select
                                    style={{ width: '45%' }}
                                    placeholder="To"
                                    value={slot.to || null}
                                    onChange={(value) =>
                                        handleBlockTimeChange(
                                            index,
                                            'to',
                                            value
                                        )
                                    }
                                >
                                    {Array.from(
                                        { length: 24 },
                                        (_, i) => `${i + 1}:00`
                                    )
                                        .filter((hour) => {
                                            const fromHour = slot.from
                                                ? parseInt(slot.from)
                                                : 0;
                                            return (
                                                parseInt(hour) > fromHour &&
                                                !blockedHours.has(hour)
                                            );
                                        })
                                        .map((hour) => (
                                            <Select.Option
                                                key={`to-${hour}`}
                                                value={hour}
                                            >
                                                {hour}
                                            </Select.Option>
                                        ))}
                                </Select>
                                <button
                                    className="btn btn-sm btn-danger"
                                    onClick={() => removeBlockTime(index)}
                                >
                                    ×
                                </button>
                            </div>
                        );
                    })}

                    <button
                        className="btn btn-primary w-100 mt-2"
                        onClick={addBlockTime}
                        type="button"
                        disabled={routine[selectedDay]?.blockedTimes?.some(
                            (slot) => !slot.from || !slot.to
                        )}
                    >
                        + Add Blocked Time
                    </button>
                </Modal>
            </div>
        );
    };

    useEffect(() => {
        dispatch(getDetails());
        dispatch(fetchAllBusinessNames());
    }, []);

    useEffect(() => {
        setBookingPeriod(businessDetails?.business?.bookingPeriod || '');
        setCancellationType(
            businessDetails?.business?.cancellationType || 'moderate'
        );
        setPolicies(businessDetails?.business?.policies || '');
        setName(businessDetails?.business?.name || '');
        setAbout(businessDetails?.business?.about || '');
        setEmail(businessDetails?.email || '');
        setLocation(businessDetails?.business?.address || '');
        setLatitude(businessDetails?.business?.latitude || '');
        setLongitude(businessDetails?.business?.longitude || '');
        setPhone(businessDetails?.phone.split('-')[1] || '');
        setCountryCode(businessDetails?.phone.split('-')[0] || '+42');
        setWebsite(businessDetails?.business?.website || '');
        setBufferTime(businessDetails?.business?.bufferTime || '');
        setFb(businessDetails?.business?.facebook || '');
        setInsta(businessDetails?.business?.Instagram || '');
        setImages(businessDetails?.business?.pictures || []);
        setDepositPercentage(
            businessDetails?.business?.depositPercentage || null
        );
        if (instaImgFiles && instaImgFiles.length > 0) {
            setImages((prev) => [...prev, ...instaImgFiles]);
        }
        setSelectedServices(businessDetails?.business?.categories || []);
        setIsOnline(
            businessDetails?.business?.address === '' &&
                businessDetails?.business?.latitude === '' &&
                businessDetails?.business?.longitude === ''
                ? true
                : false
        );
        setRoutine(
            businessDetails?.business?.openingTimes
                ? Object.fromEntries(
                      Object.entries(
                          businessDetails?.business?.openingTimes
                      ).map(([day, times]) => [
                          day,
                          {
                              from: times?.from || null,
                              to: times?.to || null,
                              isOpened: times?.isOpened === 'true',
                              blockedTimes: Array.isArray(times?.blockedTimes)
                                  ? times.blockedTimes.map((block) => ({
                                        from: block.from || null,
                                        to: block.to || null,
                                    }))
                                  : [],
                          },
                      ])
                  )
                : {
                      Sunday: {
                          from: null,
                          to: null,
                          isOpened: false,
                          blockedTimes: [],
                      },
                      Monday: {
                          from: null,
                          to: null,
                          isOpened: false,
                          blockedTimes: [],
                      },
                      Tuesday: {
                          from: null,
                          to: null,
                          isOpened: false,
                          blockedTimes: [],
                      },
                      Wednesday: {
                          from: null,
                          to: null,
                          isOpened: false,
                          blockedTimes: [],
                      },
                      Thursday: {
                          from: null,
                          to: null,
                          isOpened: false,
                          blockedTimes: [],
                      },
                      Friday: {
                          from: null,
                          to: null,
                          isOpened: false,
                          blockedTimes: [],
                      },
                      Saturday: {
                          from: null,
                          to: null,
                          isOpened: false,
                          blockedTimes: [],
                      },
                  }
        );

        setTimeout(() => {
            dispatch(resetInstaFiles());
        }, 4000);
    }, [businessDetails]);

    // ======================
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [accessToken, setAccessToken] = useState('');
    const [instaImages, setInstaImages] = useState([]);
    const path = window.location.pathname;

    // GET Images From Instagram
    useEffect(() => {
        if (path.includes('upload-from-instagram')) {
            const exchangeCodeForToken = async (code) => {
                try {
                    const response = await axiosInstance.post(
                        'instagram/token',
                        {
                            code,
                        }
                    );
                    const accessToken = response.data.access_token;
                    setAccessToken(accessToken);
                } catch (error) {
                    throw error;
                }
            };

            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code');
            if (code) {
                exchangeCodeForToken(code);
            }
        }
    }, [path]);

    useEffect(() => {
        const fetchUserImages = async () => {
            try {
                const response = await axios.get(
                    `https://graph.instagram.com/me/media?fields=id,media_type,media_url,thumbnail_url&access_token=${accessToken}`
                );
                let images = response.data.data;
                let filteredImages = images.filter(
                    (item) => item.media_type === 'IMAGE'
                );
                setInstaImages(filteredImages);
                setIsModalOpen(true);
            } catch (error) {
                console.error('Error fetching user images:', error);
            }
        };

        if (accessToken) {
            fetchUserImages();
        }
    }, [accessToken]);

    // ===========================

    const capitalizeFirstLetter = (string) => {
        if (!string) return string;
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const handleCopyClick = async () => {
        let url = userData
            ? `${window.location.origin}/register?referral=${userData?.id}`
            : window.location.href;
        navigator.clipboard.writeText(url);
        toast.success('Referral link copied');
    };
    const handleShareProfile = async () => {
        const businessName = userData?.business?.name
            ?.toLowerCase()
            .replace(/\s+/g, '-');
        //   const referralId = userData?.id;

        const url = userData
            ? `${window.location.origin}/stylist/${businessName}`
            : window.location.href;

        await navigator.clipboard.writeText(url);
        toast.success('Profile link copied to clipboard');
    };

    const handleInstagramLogin = () => {
        const clientId = IG_APP_ID;
        const redirectUri = 'https://tissume-dev.web.app/upload-from-instagram';
        const state = Math.random().toString(36).substring(7);

        const authUrl = new URL('https://api.instagram.com/oauth/authorize');
        authUrl.searchParams.append('client_id', clientId);
        authUrl.searchParams.append('redirect_uri', redirectUri);
        authUrl.searchParams.append(
            'scope',
            'instagram_business_basic,instagram_business_manage_messages,instagram_business_manage_comments,instagram_business_content_publish,instagram_business_manage_insights'
        );
        authUrl.searchParams.append('response_type', 'code');
        authUrl.searchParams.append('state', state);

        window.location.href = authUrl.toString();
    };

    return (
        <>
            {!businessDetails || fetchLoading ? (
                <Loading />
            ) : (
                <div className={`container-fluid`}>
                    <div className={`row`}>
                        <div className={`col-12 px-0 bg-ff br-top-left-22`}>
                            <Navbar />

                            <AddProductForm
                                className={`border-1-md-e1e6ef br-24 mt-0 mx-md-24 mb-20`}
                            >
                                <h6
                                    className={`m-0 pt-60 pb-md-40 f-28 fw-normal poly c-0f151d text-center`}
                                >
                                    Business details
                                </h6>

                                <form onSubmit={handleSubmit}>
                                    <BasicFormWrapper>
                                        <div className="add-product-block max-w-605 mx-auto bg-white border-1-md-e1e6ef br-24 pt-50 pb-60 mb-50">
                                            <div
                                                className={`max-w-485 mx-auto`}
                                            >
                                                <div className="d-flex flex-row-reverse gap-2">
                                                    {' '}
                                                    <div className="border-card-pill mb-3">
                                                        <div
                                                            className="py-1 px-2 "
                                                            onClick={
                                                                handleCopyClick
                                                            }
                                                        >
                                                            <span
                                                                className="poppins f-14 lh-20 c-334155s"
                                                                role="button"
                                                            >
                                                                Referral Link
                                                            </span>
                                                            <span className="fw-medium ps-2">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 448 512"
                                                                    width="12"
                                                                    height="12"
                                                                >
                                                                    <path d="M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z" />
                                                                </svg>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="border-card-pill mb-3">
                                                        <div
                                                            className="py-1 px-2 "
                                                            onClick={
                                                                handleShareProfile
                                                            }
                                                        >
                                                            <span
                                                                title="Share your profile link"
                                                                className="poppins f-14 lh-20 c-334155s"
                                                                role="button"
                                                            >
                                                                Share profile
                                                            </span>
                                                            <span className="fw-medium ps-2">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 448 512"
                                                                    width="12"
                                                                    height="12"
                                                                >
                                                                    <path d="M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z" />
                                                                </svg>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <h6
                                                    className={`m-0 pb-12 f-22 fw-normal poly c-0f151d`}
                                                >
                                                    Business info
                                                </h6>

                                                <span
                                                    className={`d-block f-14 fw-normal text-gray pb-24 poppins`}
                                                >
                                                    Your business name is
                                                    displayed across many areas
                                                    including on your online
                                                    booking profile, sales
                                                    receipts and messages to
                                                    clients
                                                </span>
                                                <div className="pb-16">
                                                    <h6 className="f-14 fw-normal poppins text-gray">
                                                        Business name
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </h6>
                                                    <label
                                                        className="label-search w-100"
                                                        htmlFor="header-search"
                                                    >
                                                        <input
                                                            className="input-search ps-0"
                                                            type="text"
                                                            name="name"
                                                            value={name}
                                                            placeholder="Business name"
                                                            onChange={(e) => {
                                                                const newName =
                                                                    e.target
                                                                        .value;
                                                                const normalizedNewName =
                                                                    newName
                                                                        .toLowerCase()
                                                                        .replace(
                                                                            /\s+/g,
                                                                            '-'
                                                                        );
                                                                const normalizedBusinessNames =
                                                                    businessNames.map(
                                                                        (bn) =>
                                                                            bn
                                                                                .toLowerCase()
                                                                                .replace(
                                                                                    /\s+/g,
                                                                                    '-'
                                                                                )
                                                                    );

                                                                setName(
                                                                    newName
                                                                );

                                                                if (
                                                                    userData?.business?.name
                                                                        ?.toLowerCase()
                                                                        .replace(
                                                                            /\s+/g,
                                                                            '-'
                                                                        ) ===
                                                                    normalizedNewName
                                                                ) {
                                                                    setErrors(
                                                                        (
                                                                            prevErrors
                                                                        ) => {
                                                                            const {
                                                                                name,
                                                                                ...rest
                                                                            } =
                                                                                prevErrors;
                                                                            return rest;
                                                                        }
                                                                    );
                                                                    return;
                                                                }

                                                                if (
                                                                    normalizedBusinessNames.includes(
                                                                        normalizedNewName
                                                                    )
                                                                ) {
                                                                    setErrors(
                                                                        (
                                                                            prevErrors
                                                                        ) => ({
                                                                            ...prevErrors,
                                                                            name: 'This business name already exists.',
                                                                        })
                                                                    );
                                                                } else {
                                                                    setErrors(
                                                                        (
                                                                            prevErrors
                                                                        ) => {
                                                                            const {
                                                                                name,
                                                                                ...rest
                                                                            } =
                                                                                prevErrors;
                                                                            return rest;
                                                                        }
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    </label>
                                                    {errors.name && (
                                                        <p className="text-danger fs-12">
                                                            {errors.name}
                                                        </p>
                                                    )}
                                                </div>

                                                <div className="mb-3">
                                                    <h6 className="f-14 fw-normal poppins text-gray">
                                                        About
                                                    </h6>
                                                    <label
                                                        className="w-100"
                                                        htmlFor="about"
                                                    >
                                                        <ReactQuill
                                                            id="about"
                                                            theme="snow"
                                                            value={about}
                                                            onChange={setAbout}
                                                            placeholder="Enter a short description here..."
                                                            style={{
                                                                height: '200px',
                                                            }}
                                                        />
                                                    </label>
                                                </div>

                                                <div className={`pb-16`}>
                                                    <h6
                                                        className={`f-14 fw-normal poppins text-gray`}
                                                    >
                                                        Email address
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </h6>
                                                    <label
                                                        className={`label-search w-100`}
                                                        htmlFor={'email'}
                                                    >
                                                        <input
                                                            className={`input-search ps-0`}
                                                            type="text"
                                                            name="email"
                                                            value={email}
                                                            placeholder={`Enter business email address`}
                                                            onChange={(e) =>
                                                                setEmail(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            disabled
                                                        />
                                                    </label>
                                                </div>

                                                <div className={`pb-16`}>
                                                    <h6
                                                        className={`f-14 fw-normal poppins text-gray`}
                                                    >
                                                        Contact number
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </h6>
                                                    <div className="input-group input-filed">
                                                        <span
                                                            className="input-group-text border-0 py-0 ps-0 bg-transparent"
                                                            id="basic-addon1"
                                                        >
                                                            <div className="dropdown">
                                                                <button
                                                                    className="btn btn-country-num dropdown-toggle"
                                                                    type="button"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <div className="container-fluid">
                                                                        <div className="row">
                                                                            <div className="col px-0">
                                                                                {
                                                                                    countryCode
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </button>
                                                                <div className="dropdown-menu country-dropdown-menu">
                                                                    <input
                                                                        className="country-dropdown-input"
                                                                        type="text"
                                                                        placeholder="Search for a country..."
                                                                        value={
                                                                            searchTerm
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            setSearchTerm(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                    />
                                                                    {filteredOptions.map(
                                                                        (
                                                                            _country
                                                                        ) => (
                                                                            <p
                                                                                key={
                                                                                    _country.label
                                                                                }
                                                                                className="dropdown-item cp"
                                                                                onClick={() =>
                                                                                    handleCountryCodeClick(
                                                                                        _country
                                                                                    )
                                                                                }
                                                                            >
                                                                                {
                                                                                    _country.flag
                                                                                }{' '}
                                                                                {
                                                                                    _country.label
                                                                                }{' '}
                                                                                {
                                                                                    _country.code
                                                                                }
                                                                            </p>
                                                                        )
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </span>
                                                        <input
                                                            type="number"
                                                            name="phone"
                                                            value={phone}
                                                            onChange={(e) =>
                                                                setPhone(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            className="form-control border-0 py-0 box-shadow-0"
                                                            placeholder={`Enter business mobile number`}
                                                        />
                                                    </div>
                                                    {errors.phone && (
                                                        <p className="text-danger fs-12">
                                                            {errors.phone}
                                                        </p>
                                                    )}
                                                </div>

                                                <h6
                                                    className={`f-14 fw-normal poppins text-gray`}
                                                >
                                                    Edit Pictures
                                                </h6>
                                                <div className={`pb-16`}>
                                                    <input
                                                        className="d-none"
                                                        type="file"
                                                        id="fileInput"
                                                        accept="image/jpeg, image/png, image/jpg"
                                                        multiple
                                                        onChange={
                                                            handleImageChange
                                                        }
                                                    />
                                                    <div className="d-flex flex-row flex-wrap gap-2">
                                                        <div className="image-dimentions doted-border bg-white p-1 d-flex flex-column justify-content-center align-items-center gap-1">
                                                            <label
                                                                htmlFor="fileInput"
                                                                role="button"
                                                                className=" d-flex justify-content-center align-items-center gap-1 poppins text-center p-1 m-0 rounded-pill fs-9"
                                                            >
                                                                {' '}
                                                                <span className="pt-1 fs-11">
                                                                    <div className="mb-2">
                                                                        <img
                                                                            src={
                                                                                plusIcon
                                                                            }
                                                                            height={
                                                                                25
                                                                            }
                                                                            width={
                                                                                25
                                                                            }
                                                                            alt="icon"
                                                                        />
                                                                    </div>
                                                                    Add Image
                                                                    from Gallery
                                                                    <br />
                                                                    or{' '}
                                                                    <button
                                                                        type="button"
                                                                        className="border-0 bg-transparent text-decoration-underline"
                                                                        onClick={
                                                                            handleInstagramLogin
                                                                        }
                                                                        // href={`https://api.instagram.com/oauth/authorize?client_id=${IG_APP_ID}&redirect_uri=${BASEURL}/upload-from-instagram&scope=user_profile,user_media&response_type=code`}
                                                                    >
                                                                        Instagram
                                                                    </button>
                                                                </span>
                                                            </label>
                                                        </div>

                                                        {images.map(
                                                            (img, index) => (
                                                                <div
                                                                    className="image-dimentions position-relative"
                                                                    key={index}
                                                                >
                                                                    <div className="cancel-pic">
                                                                        <button
                                                                            type="button"
                                                                            className="border-0 rounded-3"
                                                                            disabled={
                                                                                updateLoading
                                                                            }
                                                                            onClick={() =>
                                                                                handleRemoveImage(
                                                                                    img.id,
                                                                                    index
                                                                                )
                                                                            }
                                                                        >
                                                                            {updateLoading ? (
                                                                                <Spin />
                                                                            ) : (
                                                                                <svg
                                                                                    width="14"
                                                                                    height="16"
                                                                                    fill="none"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    viewBox="0 0 448 512"
                                                                                >
                                                                                    <path
                                                                                        d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1 -32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1 -32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1 -32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.7 23.7 0 0 0 -21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0 -16-16z"
                                                                                        fill="red"
                                                                                    />
                                                                                </svg>
                                                                            )}
                                                                        </button>
                                                                    </div>
                                                                    <img
                                                                        src={
                                                                            img.photo_path ||
                                                                            img.previewPic
                                                                        }
                                                                        alt="image"
                                                                        className="w-100 h-100 object-fit-fill"
                                                                    />
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                    {errors.images && (
                                                        <p className="text-danger fs-12">
                                                            {errors.images}
                                                        </p>
                                                    )}
                                                </div>

                                                <div
                                                    className={`col-md-12 pb-20`}
                                                >
                                                    <h6
                                                        className={`f-14 fw-normal poppins text-gray`}
                                                    >
                                                        Business Location
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </h6>
                                                    <label
                                                        className={`label-search w-100`}
                                                    >
                                                        <Autocomplete
                                                            onLoad={(
                                                                autocomplete
                                                            ) => {
                                                                setData(
                                                                    autocomplete
                                                                );
                                                            }}
                                                            onPlaceChanged={() => {
                                                                handleLocationLatLng();
                                                            }}
                                                        >
                                                            <input
                                                                type="text"
                                                                value={
                                                                    location ===
                                                                    'null'
                                                                        ? null
                                                                        : location
                                                                }
                                                                onChange={(e) =>
                                                                    setLocation(
                                                                        e.target
                                                                            .value
                                                                    )
                                                                }
                                                                className="input-search ps-0"
                                                                placeholder="Choose location"
                                                                disabled={
                                                                    isOnline
                                                                }
                                                            />
                                                        </Autocomplete>
                                                    </label>

                                                    {errors.location && (
                                                        <p className="text-danger fs-12">
                                                            {errors.location}
                                                        </p>
                                                    )}

                                                    {/* <div
                                                        className={`col-md-12 mt-3`}
                                                    >
                                                        <div className="form-check d-flex align-items-md-start align-items-center">
                                                            <input
                                                                className="form-check-input check-box-custom cp"
                                                                type="checkbox"
                                                                checked={
                                                                    isOnline
                                                                }
                                                                onChange={
                                                                    handleIsOnline
                                                                }
                                                            />
                                                            <label className="form-check-label c-667085 poppins f-14 fw-normal lh-23 ps-2">
                                                                I don’t have a
                                                                business address
                                                                (mobile and
                                                                online services
                                                                only)
                                                            </label>
                                                        </div>
                                                    </div> */}
                                                </div>

                                                {/* Cancelation Policy */}
                                                <div
                                                    className={`border-b-1-e1e6ef my-30`}
                                                />
                                                <h6
                                                    className={`m-0 pb-12 f-22 fw-normal poly c-0f151d`}
                                                >
                                                    Cancelation Policy
                                                </h6>

                                                <div className={` `}>
                                                    <h6
                                                        className={`f-14 mt-2 fw-normal poppins text-gray`}
                                                    >
                                                        Cancellation Type
                                                    </h6>
                                                    <label
                                                        className={`label-search position-relative
                                                        w-100 h__48 d-flex align-items-center cp relative`}
                                                        onClick={
                                                            toggleCancellationType
                                                        }
                                                        ref={cancellationRef}
                                                    >
                                                        {cancellationType ? (
                                                            capitalizeFirstLetter(
                                                                cancellationType
                                                            )
                                                        ) : (
                                                            <span className="text-gray">
                                                                {' '}
                                                                Choose Type
                                                            </span>
                                                        )}

                                                        {isCancellationTypeOpen && (
                                                            <div
                                                                className="cancellation-type-dropdown pt-3"
                                                                // ref={
                                                                //     cancellationRef
                                                                // }
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.stopPropagation();
                                                                }}
                                                            >
                                                                {/* Your dropdown options go here */}
                                                                {cancellationTypes?.map(
                                                                    (
                                                                        type,
                                                                        idx
                                                                    ) => {
                                                                        return (
                                                                            <div
                                                                                className={`d-flex flex-column cancellation-type-dropdown-item poppins pb-2 px-2 ${
                                                                                    idx +
                                                                                        1 !=
                                                                                    cancellationTypes.length
                                                                                        ? 'cancellation-border-bottom mb-2'
                                                                                        : 'mb-1'
                                                                                }`}
                                                                                key={
                                                                                    idx
                                                                                }
                                                                                onClick={() => {
                                                                                    setCancellationType(
                                                                                        type?.title
                                                                                    );
                                                                                    setCancellationTypeOpen(
                                                                                        false
                                                                                    );
                                                                                }}
                                                                            >
                                                                                <span className="cancellation-type-dropdown-item-title">
                                                                                    {' '}
                                                                                    {capitalizeFirstLetter(
                                                                                        type?.title
                                                                                    )}
                                                                                </span>
                                                                                <span className="cancellation-type-dropdown-item-description">
                                                                                    {
                                                                                        type?.description
                                                                                    }
                                                                                </span>
                                                                            </div>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        )}
                                                    </label>
                                                </div>

                                                {/* Cancelation Policy */}
                                                <div className="border-b-1-e1e6ef my-30" />

                                                <h6 className="m-0 mb-1 pb-12 f-22 fw-normal poly c-0f151d">
                                                    Booking Rules & Policy
                                                </h6>

                                                <div>
                                                    <label className="w-100">
                                                        <ReactQuill
                                                            theme="snow"
                                                            value={policies}
                                                            onChange={
                                                                setPolicies
                                                            }
                                                            placeholder="Enter rules and policy"
                                                            style={{
                                                                height: '200px',
                                                            }}
                                                        />
                                                    </label>
                                                </div>

                                                <div
                                                    className={`border-b-1-e1e6ef my-30`}
                                                />

                                                <div className={`pb-16 w-100 `}>
                                                    <h6
                                                        className={`f-14 fw-normal poppins text-gray`}
                                                    >
                                                        Advanced booking period
                                                    </h6>
                                                    <label
                                                        className={`label-search  position-relative poppins w-100`}
                                                        // htmlFor={
                                                        //     'header-search'
                                                        // }
                                                    >
                                                        <input
                                                            className={`input-search ps-0`}
                                                            type="text"
                                                            name="bookingPeriod"
                                                            value={
                                                                bookingPeriod
                                                            }
                                                            // placeholder={`Business name`}
                                                            onChange={(e) => {
                                                                const inputValue =
                                                                    e.target
                                                                        .value;
                                                                // Validate if the input is a positive number (excluding zero)
                                                                if (
                                                                    inputValue ==
                                                                    ''
                                                                ) {
                                                                    setBookingPeriod(
                                                                        null
                                                                    );
                                                                } else if (
                                                                    /^\d*[1-9]\d*$/.test(
                                                                        inputValue
                                                                    )
                                                                ) {
                                                                    setBookingPeriod(
                                                                        inputValue
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                        <div
                                                            className="input-unit"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            days
                                                        </div>
                                                    </label>
                                                </div>
                                                <div className="pb-16 w-100">
                                                    <h6 className="f-14 fw-normal poppins text-gray">
                                                        Select your service
                                                        buffer time (in minutes)
                                                    </h6>
                                                    <Select
                                                        className="w-100"
                                                        value={bufferTime}
                                                        onChange={(value) =>
                                                            setBufferTime(value)
                                                        }
                                                        placeholder="Select buffer time"
                                                    >
                                                        {[15, 30, 45, 60].map(
                                                            (minutes) => (
                                                                <Select.Option
                                                                    key={
                                                                        minutes
                                                                    }
                                                                    value={
                                                                        minutes
                                                                    }
                                                                >
                                                                    {minutes}{' '}
                                                                    minutes
                                                                </Select.Option>
                                                            )
                                                        )}
                                                    </Select>
                                                </div>
                                                <div className="pb-16 w-100">
                                                    <h6 className="f-14 fw-normal poppins text-gray">
                                                        Upfront Deposit
                                                        Percentage
                                                    </h6>
                                                    <Select
                                                        className="w-100"
                                                        value={
                                                            depositPercentage
                                                        }
                                                        onChange={(value) =>
                                                            setDepositPercentage(
                                                                value
                                                            )
                                                        }
                                                        placeholder="Select Upfront Deposit Percentage"
                                                    >
                                                        <Select.Option
                                                            value={null}
                                                        >
                                                            Select Percentage
                                                        </Select.Option>
                                                        {[10, 20, 30, 50].map(
                                                            (percent) => (
                                                                <Select.Option
                                                                    key={
                                                                        percent
                                                                    }
                                                                    value={
                                                                        percent
                                                                    }
                                                                >
                                                                    {percent}{' '}
                                                                    Percent
                                                                </Select.Option>
                                                            )
                                                        )}
                                                    </Select>
                                                </div>
                                                <div className={`mb-20`}>
                                                    <h6
                                                        className={`f-14 fw-normal poppins text-gray`}
                                                    >
                                                        Opening time
                                                    </h6>
                                                    <div className="border rounded">
                                                        <div className="m-3">
                                                            <div className="d-flex items-align-center gap-2 mb-2">
                                                                <input
                                                                    type="checkbox"
                                                                    role="button"
                                                                    checked={
                                                                        applyAll
                                                                    }
                                                                    onChange={() =>
                                                                        setApplyAll(
                                                                            !applyAll
                                                                        )
                                                                    }
                                                                />
                                                                <p className="m-0">
                                                                    Apply same
                                                                    time to all
                                                                </p>
                                                            </div>
                                                            {Object.keys(
                                                                routine
                                                            ).map((day) =>
                                                                handleRoutine(
                                                                    day
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className={`mb-20`}>
                                                    <label
                                                        htmlFor="businessName"
                                                        className="form-label f-14 fw-normal poppins text-gray"
                                                    >
                                                        Services
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </label>
                                                    <div
                                                        className={`d-flex flex-wrap position-relative`}
                                                    >
                                                        {SERVICES.map(
                                                            (
                                                                service,
                                                                index
                                                            ) => (
                                                                <div
                                                                    key={index}
                                                                    className={`custom-service-col`}
                                                                    title={
                                                                        service.name
                                                                    }
                                                                >
                                                                    <label className="checkbox-container">
                                                                        <input
                                                                            className={`step-input`}
                                                                            checked={selectedServices.includes(
                                                                                service.name
                                                                            )}
                                                                            onChange={() =>
                                                                                handleServiceChange(
                                                                                    service.name
                                                                                )
                                                                            }
                                                                            type="checkbox"
                                                                        />
                                                                        <div
                                                                            className={`container-fluid pt-32 pb-22 checked-color`}
                                                                        >
                                                                            <div
                                                                                className={`row justify-content-center h-84`}
                                                                            >
                                                                                <div
                                                                                    className={`col-12 px-0 text-center`}
                                                                                >
                                                                                    <SVG
                                                                                        icon={
                                                                                            service.icon
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                                <div
                                                                                    className={`col-12 px-0 w-200`}
                                                                                >
                                                                                    <h6
                                                                                        className={`mb-0 mx-auto checked-text p-2 responsive-service-text`}
                                                                                        style={{
                                                                                            fontSize:
                                                                                                '11px',
                                                                                        }}
                                                                                    >
                                                                                        {
                                                                                            service.name
                                                                                        }
                                                                                    </h6>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <span
                                                                            className={`bg-checkbox`}
                                                                        >
                                                                            <span className="checkmark"></span>
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                            )
                                                        )}
                                                        {errors.services && (
                                                            <p className="text-danger fs-12">
                                                                {
                                                                    errors.services
                                                                }
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>

                                                {userData?.subscription?.id && (
                                                    <>
                                                        <div
                                                            className={`border-b-1-e1e6ef my-30`}
                                                        />

                                                        <h6
                                                            className={`m-0 pb-12 f-22 fw-normal poly c-0f151d`}
                                                        >
                                                            Subscription
                                                            settings
                                                        </h6>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span className="f-15 poppins c-667085">
                                                                Subscription
                                                                Status
                                                            </span>

                                                            <span className="active-badge">
                                                                <span>
                                                                    Active
                                                                </span>
                                                            </span>
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                                            <span className="f-15 poppins c-667085 fw-400 w-60">
                                                                Subscription
                                                                expiry date
                                                            </span>
                                                            <span>
                                                                <span className="poppins fs-14 c-333333 w-40 ms-1">
                                                                    {moment
                                                                        .unix(
                                                                            userData
                                                                                ?.subscription
                                                                                ?.expired_at
                                                                        )
                                                                        .format(
                                                                            'DD/MM/YYYY'
                                                                        )}
                                                                </span>
                                                            </span>
                                                        </div>
                                                        {!userData?.subscription
                                                            ?.is_deleted && (
                                                            <div className="d-flex justify-content-between align-items-center mt-2">
                                                                <a
                                                                    className="f-16 poppins c-f93232 fw-400 text-danger"
                                                                    onClick={() =>
                                                                        setIsSubscriptionModalOpen(
                                                                            true
                                                                        )
                                                                    }
                                                                >
                                                                    Cancel
                                                                    Subscription
                                                                </a>
                                                                <span></span>
                                                            </div>
                                                        )}
                                                    </>
                                                )}

                                                <div
                                                    className={`border-b-1-e1e6ef my-30`}
                                                />

                                                <h6
                                                    className={`m-0 pb-12 f-22 fw-normal poly c-0f151d`}
                                                >
                                                    Online links
                                                </h6>

                                                <span
                                                    className={`d-block f-14 fw-normal text-gray pb-24 poppins`}
                                                >
                                                    Add your company website and
                                                    social media links for
                                                    sharing with clients
                                                </span>

                                                <div className={`pb-16`}>
                                                    <h6
                                                        className={`f-14 fw-normal poppins text-gray`}
                                                    >
                                                        Website
                                                    </h6>
                                                    <label
                                                        className={`label-search w-100`}
                                                        htmlFor={
                                                            'header-search'
                                                        }
                                                    >
                                                        <div
                                                            className={`container-fluid`}
                                                        >
                                                            <div
                                                                className={`row align-items-center`}
                                                            >
                                                                <div
                                                                    className={`col-auto px-0 lh-0`}
                                                                >
                                                                    <svg
                                                                        width="20"
                                                                        height="20"
                                                                        viewBox="0 0 20 20"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM16.8461 9.375H13.7344C13.6242 7.15156 12.932 5.04141 11.7719 3.35938C13.1306 3.72417 14.3452 4.49613 15.2523 5.57152C16.1594 6.64691 16.7156 7.97419 16.8461 9.375ZM10 16.8664C8.53672 15.2828 7.64922 13.0383 7.51797 10.625H12.482C12.3508 13.0367 11.4633 15.2828 10 16.8664ZM7.51797 9.375C7.64922 6.96328 8.5336 4.71719 10 3.13359C11.4633 4.71719 12.3508 6.96172 12.482 9.375H7.51797ZM8.22813 3.35938C7.06797 5.04141 6.37578 7.15156 6.26563 9.375H3.15391C3.28444 7.97419 3.84063 6.64691 4.74773 5.57152C5.65483 4.49613 6.86937 3.72417 8.22813 3.35938ZM3.15391 10.625H6.26563C6.37578 12.8484 7.06797 14.9586 8.22813 16.6406C6.86937 16.2758 5.65483 15.5039 4.74773 14.4285C3.84063 13.3531 3.28444 12.0258 3.15391 10.625ZM11.7719 16.6406C12.932 14.9563 13.6242 12.8461 13.7344 10.625H16.8461C16.7156 12.0258 16.1594 13.3531 15.2523 14.4285C14.3452 15.5039 13.1306 16.2758 11.7719 16.6406Z"
                                                                            fill="#667085"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                                <div
                                                                    className={`col px-0`}
                                                                >
                                                                    <input
                                                                        className={`input-search w-100`}
                                                                        type="text"
                                                                        name="website"
                                                                        value={
                                                                            website
                                                                        }
                                                                        placeholder={`https://www.yourwebsite.com`}
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            setWebsite(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </label>
                                                    {errors.website && (
                                                        <p className="text-danger fs-12">
                                                            {errors.website}
                                                        </p>
                                                    )}
                                                </div>

                                                <div className={`pb-16`}>
                                                    <h6
                                                        className={`f-14 fw-normal poppins text-gray`}
                                                    >
                                                        Facebook page
                                                    </h6>
                                                    <label
                                                        className={`label-search w-100`}
                                                        htmlFor={
                                                            'header-search'
                                                        }
                                                    >
                                                        <div
                                                            className={`container-fluid`}
                                                        >
                                                            <div
                                                                className={`row align-items-center`}
                                                            >
                                                                <div
                                                                    className={`col-auto px-0 lh-0`}
                                                                >
                                                                    <svg
                                                                        width="20"
                                                                        height="20"
                                                                        viewBox="0 0 20 20"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM10.625 16.8461V11.875H12.5C12.6658 11.875 12.8247 11.8092 12.9419 11.6919C13.0592 11.5747 13.125 11.4158 13.125 11.25C13.125 11.0842 13.0592 10.9253 12.9419 10.8081C12.8247 10.6908 12.6658 10.625 12.5 10.625H10.625V8.75C10.625 8.41848 10.7567 8.10054 10.9911 7.86612C11.2255 7.6317 11.5435 7.5 11.875 7.5H13.125C13.2908 7.5 13.4497 7.43415 13.5669 7.31694C13.6842 7.19973 13.75 7.04076 13.75 6.875C13.75 6.70924 13.6842 6.55027 13.5669 6.43306C13.4497 6.31585 13.2908 6.25 13.125 6.25H11.875C11.212 6.25 10.5761 6.51339 10.1072 6.98223C9.6384 7.45107 9.375 8.08696 9.375 8.75V10.625H7.5C7.33424 10.625 7.17527 10.6908 7.05806 10.8081C6.94085 10.9253 6.875 11.0842 6.875 11.25C6.875 11.4158 6.94085 11.5747 7.05806 11.6919C7.17527 11.8092 7.33424 11.875 7.5 11.875H9.375V16.8461C7.61312 16.6853 5.98107 15.8514 4.81831 14.5179C3.65556 13.1845 3.05162 11.4541 3.13212 9.68674C3.21263 7.91936 3.97137 6.25106 5.25053 5.02883C6.52969 3.80661 8.2308 3.12456 10 3.12456C11.7692 3.12456 13.4703 3.80661 14.7495 5.02883C16.0286 6.25106 16.7874 7.91936 16.8679 9.68674C16.9484 11.4541 16.3444 13.1845 15.1817 14.5179C14.0189 15.8514 12.3869 16.6853 10.625 16.8461Z"
                                                                            fill="#667085"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                                <div
                                                                    className={`col px-0`}
                                                                >
                                                                    <input
                                                                        className={`input-search w-100`}
                                                                        type="text"
                                                                        name="fb"
                                                                        value={
                                                                            fb
                                                                        }
                                                                        placeholder={`https://www.facebook.com/yourpage`}
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            setFb(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </label>
                                                    {errors.fb && (
                                                        <p className="text-danger fs-12">
                                                            {errors.fb}
                                                        </p>
                                                    )}
                                                </div>

                                                <div className={`pb-16`}>
                                                    <h6
                                                        className={`f-14 fw-normal poppins text-gray`}
                                                    >
                                                        Instagram page
                                                    </h6>
                                                    <label
                                                        className={`label-search w-100`}
                                                        htmlFor={
                                                            'header-search'
                                                        }
                                                    >
                                                        <div
                                                            className={`container-fluid`}
                                                        >
                                                            <div
                                                                className={`row align-items-center`}
                                                            >
                                                                <div
                                                                    className={`col-auto px-0 lh-0`}
                                                                >
                                                                    <svg
                                                                        width="20"
                                                                        height="20"
                                                                        viewBox="0 0 20 20"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M10 6.25C9.25832 6.25 8.5333 6.46993 7.91661 6.88199C7.29993 7.29404 6.81928 7.87971 6.53545 8.56494C6.25162 9.25016 6.17736 10.0042 6.32206 10.7316C6.46675 11.459 6.8239 12.1272 7.34835 12.6517C7.8728 13.1761 8.54098 13.5333 9.26841 13.6779C9.99584 13.8226 10.7498 13.7484 11.4351 13.4645C12.1203 13.1807 12.706 12.7001 13.118 12.0834C13.5301 11.4667 13.75 10.7417 13.75 10C13.749 9.00576 13.3535 8.05253 12.6505 7.34949C11.9475 6.64645 10.9942 6.25103 10 6.25ZM10 12.5C9.50555 12.5 9.0222 12.3534 8.61107 12.0787C8.19995 11.804 7.87952 11.4135 7.6903 10.9567C7.50108 10.4999 7.45157 9.99723 7.54804 9.51227C7.6445 9.02732 7.8826 8.58186 8.23223 8.23223C8.58186 7.8826 9.02732 7.6445 9.51227 7.54804C9.99723 7.45157 10.4999 7.50108 10.9567 7.6903C11.4135 7.87952 11.804 8.19995 12.0787 8.61107C12.3534 9.0222 12.5 9.50555 12.5 10C12.5 10.663 12.2366 11.2989 11.7678 11.7678C11.2989 12.2366 10.663 12.5 10 12.5ZM13.75 1.875H6.25C5.09006 1.87624 3.97798 2.33758 3.15778 3.15778C2.33758 3.97798 1.87624 5.09006 1.875 6.25V13.75C1.87624 14.9099 2.33758 16.022 3.15778 16.8422C3.97798 17.6624 5.09006 18.1238 6.25 18.125H13.75C14.9099 18.1238 16.022 17.6624 16.8422 16.8422C17.6624 16.022 18.1238 14.9099 18.125 13.75V6.25C18.1238 5.09006 17.6624 3.97798 16.8422 3.15778C16.022 2.33758 14.9099 1.87624 13.75 1.875ZM16.875 13.75C16.875 14.5788 16.5458 15.3737 15.9597 15.9597C15.3737 16.5458 14.5788 16.875 13.75 16.875H6.25C5.4212 16.875 4.62634 16.5458 4.04029 15.9597C3.45424 15.3737 3.125 14.5788 3.125 13.75V6.25C3.125 5.4212 3.45424 4.62634 4.04029 4.04029C4.62634 3.45424 5.4212 3.125 6.25 3.125H13.75C14.5788 3.125 15.3737 3.45424 15.9597 4.04029C16.5458 4.62634 16.875 5.4212 16.875 6.25V13.75ZM15 5.9375C15 6.12292 14.945 6.30418 14.842 6.45835C14.739 6.61252 14.5926 6.73268 14.4213 6.80364C14.25 6.87459 14.0615 6.89316 13.8796 6.85699C13.6977 6.82081 13.5307 6.73152 13.3996 6.60041C13.2685 6.4693 13.1792 6.30225 13.143 6.1204C13.1068 5.93854 13.1254 5.75004 13.1964 5.57873C13.2673 5.40743 13.3875 5.26101 13.5417 5.158C13.6958 5.05498 13.8771 5 14.0625 5C14.3111 5 14.5496 5.09877 14.7254 5.27459C14.9012 5.4504 15 5.68886 15 5.9375Z"
                                                                            fill="#667085"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                                <div
                                                                    className={`col px-0`}
                                                                >
                                                                    <input
                                                                        className={`input-search w-100`}
                                                                        type="text"
                                                                        name="search"
                                                                        value={
                                                                            insta
                                                                        }
                                                                        placeholder={`https://www.instagram.com/yourpage`}
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            setInsta(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </label>
                                                    {errors.insta && (
                                                        <p className="text-danger fs-12">
                                                            {errors.insta}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="d-flex w-100 justify-content-end">
                                                <button
                                                    type="submit"
                                                    className={`btn btn-prim px-4`}
                                                    disabled={updateLoading}
                                                >
                                                    {updateLoading ? (
                                                        <Spin />
                                                    ) : (
                                                        'Save'
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    </BasicFormWrapper>
                                </form>
                            </AddProductForm>
                        </div>
                    </div>

                    {isModalOpen && (
                        <div className={`modal instagram-modal`}>
                            <UploadFromInsta instaImages={instaImages} />
                        </div>
                    )}

                    <Modal
                        open={isSubscriptionModalOpen}
                        onCancel={() => setIsSubscriptionModalOpen(false)}
                        footer={null}
                    >
                        <h4>Confirmation required</h4>
                        <p className="mb-5">
                            {`Are you sure you want to cancel your subscription`}
                        </p>
                        <div className="d-flex gap-3 justify-content-end">
                            <button
                                disabled={isCancelling}
                                className="btn btn-outline"
                                onClick={() =>
                                    setIsSubscriptionModalOpen(false)
                                }
                            >
                                Cancel
                            </button>
                            <button
                                disabled={isCancelling}
                                className={`btn btn-danger `}
                                onClick={handleCancelSubscription}
                            >
                                {isCancelling ? <Spin /> : 'Yes, Proceed'}
                            </button>
                        </div>
                    </Modal>
                </div>
            )}
        </>
    );
};

export default Setting;
